module.exports = __webpack_public_path__ + "arrow_down.svg?640ef204446d6f703aff3868b5535649";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_down.svg
// module id = 29
// module chunks = 0